<script setup lang="ts">
import type { LegalSourceRelation } from "~/types/article"

defineProps<{
  note: LegalSourceRelation
}>()
</script>

<template>
  <USidenote :note="note" title-class="text-teal-dark">
    <template #sidenoteType>
      <span>
        |
        {{ note.resource.type }} <br />
        <span> {{ note.resource.typeDescription }}</span>
      </span>
    </template>
    <template #tag>
      <span
        v-if="note.resource.paragraphAndSection"
        class="w-fit rounded-md bg-teal-dark px-2.5 py-1 font-extrabold text-white"
      >{{ note.resource.paragraphAndSection }}</span>
    </template>
    <template #url>
      <a
        v-if="note.resource.url"
        class="flex flex-wrap gap-2"
        :href="note.resource.url"
        target="_blank"
      >
        <span
          class="text-[font:inherit] text-portal-indigo-600 underline decoration-grey-60 decoration-2 underline-offset-4"
        >{{ note.resource.urlTitle }}</span>
        <UIcon
          class="inline-block self-center"
          name="link-external"
          size="md"
        />
      </a>
    </template>
    <template #content>
      <div v-html="note.resource.text" />
    </template>
  </USidenote>
</template>
